import { SearchBar } from '@components/inputs/SearchBar';
import { type ChangeEvent, type FC, useState } from 'react';
import { TagsTable } from './Tables';
import { useDebounce } from 'hooks/useDebounce';
import { useTranslation } from 'react-i18next';
import { Button } from 'layout/Button';
import useDisclosure from 'hooks/useDisclosure';
import AddAssetModal from './modal/AddTagModal/AddTagModal';

const TagsListPage: FC = () => {
  const { t } = useTranslation();

  const [searchValue, setSearchValue] = useState('');

  const query = useDebounce(searchValue, 300);

  const handleSearchInput = (event: ChangeEvent<HTMLInputElement>): void => {
    setSearchValue(event.target.value);
  };

  const {
    isOpen: isAddTagOpen,
    handleClose: handleAddTagClose,
    handleOpen: handleAddTagOpen,
  } = useDisclosure();

  return (
    <div>
      <div className="flex justify-between">
        <h1>{t('common.tags')}</h1>
        <div className="flex gap-4">
          <Button
            label={t('assetsPage.assetsTab.buttons.addTag')}
            onClick={handleAddTagOpen}
            className="shadow-button"
          />
        </div>
      </div>
      <div className="flex gap-4 my-6 w-6/12">
        <div className="flex-[1.5_1_0%]">
          <SearchBar
            placeholder={t('assetsPage.placeholders.tagSearch')}
            onChange={handleSearchInput}
          />
        </div>
      </div>
      <div>
        <AddAssetModal
          isOpen={isAddTagOpen}
          handleClose={handleAddTagClose}
          handleOpen={handleAddTagOpen}
        />
        <TagsTable query={query} />
      </div>
    </div>
  );
};

export default TagsListPage;
